<template>
    <div>
        <b-row>
            <b-col>
                <b-table hover small show-empty class="sr-caption"
                    aria-live="polite"
                    responsive="true"
                    :fields="attachmentFields"
                    :items="value"
                    :busy="false"
                    label-sort-asc=""
                    label-sort-desc=""
                    caption="Attachments table.  To sort the data in this table by a specific column,
                                       go to the appropriate column header cell and use enter to sort the data ascending.
                                       Use enter again to sort descending.">
                    <template v-slot:no-data>
                        No Attachments Found.
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                    <template v-slot:cell(actions)="row">
                        <b-button size="sm" :href="row.item.url" :download="row.item.filename" target="_attach" class="mr-1">
                            download
                        </b-button>
                    </template>
                    <template slot="empty" slot-scope="scope">
                        No Attachments Found.
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</template>

<script>  
export default {
    data() {
        return {
            attachmentFields:  [

            ],
        }
    },
    props: {
        value: Array,
        internal: { type:Boolean, default:false }
    },
    created() {
        if (this.internal) {
            this.attachmentFields = [
                {key: 'filename', sortable: true, label: 'File Name'},
                {key: 'type.description', sortable: true, label: 'File Type'},
                {key: 'courseDate', sortable: true, label: 'Course Date'},
                {key: 'trainingPresenter', sortable: true, label: 'Presenter'},
                {key: 'attachedDate', sortable: true, label: 'Attached Date'},
                {key: 'attachedBy', sortable: true, label: 'Attaching UserId'},
                {key: 'actions', label: 'Actions'}
            ]
        } else {
            this.attachmentFields = [
                {key: 'filename', sortable: true, label: 'File Name'},
                {key: 'type.description', sortable: true, label: 'File Type'},
                {key: 'courseDate', sortable: true, label: 'Course Date'},
                {key: 'trainingPresenter', sortable: true, label: 'Presenter'},
                {key: 'actions', label: 'Actions'}
            ]
        }
        if (this.value.some(a => a.changeDate != null)) {
            this.attachmentFields.splice(this.attachmentFields.length -1, 0, {key:'changeDate', label: 'Date Changed', sortable:true})
        }
    }
}
</script>

<style>
</style>
